import * as React from 'react'
import ReportGroup from '../../model/ReportGroup'
import * as _ from 'lodash'
import { Dropdown, Navbar, NavDropdown, Nav, Badge } from 'react-bootstrap'
import { ReportRouteProps } from '../Router/Router'
import Market from '../../model/Market'
import { FaBolt } from 'react-icons/fa'

export interface StateProps {
  selectedMarket?: string
  selectedReportGroup?: string
  loading: boolean
  reportGroups?: _.Dictionary<ReportGroup[]>
  markets?: _.Dictionary<Market>
  additionalRoute: string
}

type Props = StateProps & ReportRouteProps

const getReportName = (
  reportGroups?: _.Dictionary<ReportGroup[]>,
  marketKey?: string,
  reportGroupKey?: string
) => {
  const reportGroupList = marketKey && reportGroups && reportGroups[marketKey]
  if (reportGroupList) {
    const reportGroup = reportGroupList.find(r => r.key === reportGroupKey)
    if (reportGroup) {
      return `Portfolio: ${reportGroup.name}`
    }
  }
  return 'Portfolio'
}

const getMarketName = (props: Props) => {
  if (props.selectedMarket && props.markets && props.markets[props.selectedMarket]) {
    return `Market: ${props.markets[props.selectedMarket].name}`
  }
  return 'Market'
}

export class ReportGroupSelectionComponent extends React.Component<Props, {}> {
  render() {
    if (this.props.loading) {
      return (
        <Badge>
          <FaBolt />
          Loading report groups...
        </Badge>
      )
    }
    return (
      <Navbar variant="dark" bg="dark">
        <Nav>
          <NavDropdown id="marketSelector" title={getMarketName(this.props)}>
            {_.toArray(
              _.mapValues(this.props.reportGroups, (reportGroups, market) =>
                market === 'global' ? null : (
                  <Dropdown.Item
                    key={this.props.markets && this.props.markets[market].name}
                    onClick={() => {
                      if (
                        this.props.reportGroups &&
                        this.props.reportGroups[market].find(
                          r => r.key === this.props.selectedReportGroup
                        )
                      ) {
                        this.props.history.push(
                          `/reports/${market}/${this.props.selectedReportGroup}${this.props.additionalRoute}`
                        )
                      } else {
                        this.props.history.push(`/reports/${market}`)
                      }
                    }}
                  >
                    {this.props.markets && this.props.markets[market].name}
                  </Dropdown.Item>
                )
              )
            )}
          </NavDropdown>
          <NavDropdown
            title={getReportName(
              this.props.reportGroups,
              this.props.selectedMarket,
              this.props.selectedReportGroup
            )}
            id="reportGroupSelector"
            disabled={!this.props.selectedMarket}
          >
            {this.props.reportGroups &&
              this.props.selectedMarket &&
              this.props.reportGroups[this.props.selectedMarket] &&
              this.props.reportGroups[this.props.selectedMarket]
                .sort((r1, r2) => r1.name.localeCompare(r2.name))
                .map(r => (
                  <Dropdown.Item
                    key={r.name}
                    onClick={() => {
                      this.props.history.push(
                        `/reports/${this.props.selectedMarket}/${r.key}${this.props.additionalRoute}`
                      )
                    }}
                  >
                    {r.name}
                  </Dropdown.Item>
                ))}
          </NavDropdown>
        </Nav>
      </Navbar>
    )
  }
}
